import { useDispatch, useSelector } from "react-redux";
import type { TypedUseSelectorHook } from "react-redux";
import type { AppDispatch, RootState } from "./store";

/**
 * Typed redux hooks (SCRUM-595). Prefer these over the bare react-redux hooks:
 * useAppSelector's `state` is RootState, and useAppDispatch accepts thunks.
 *
 * SCRUM-1995: typed assignments, checked by the compiler, where these used to be
 * JSDoc casts. Not `useDispatch.withTypes()`: 30 client suites `jest.mock`
 * react-redux with a bare `useDispatch: jest.fn()`, which has no `withTypes`,
 * and a module-load call would fail all of them. The assignment keeps the
 * runtime value exactly what it was — the react-redux hook itself.
 */
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
